<div
  class="flex min-h-screen items-center justify-center bg-gray-100 px-4 py-12 sm:px-6 lg:px-8"
  *transloco="let t; read: 'auth.verifyEmail'"
  >
  <div class="w-full max-w-md space-y-8 bg-white p-8">
    <!-- Loading State -->
    @if (isLoading) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
          <svg class="h-6 w-6 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.verifyingAccount') }}</h2>
        <p class="mt-2 text-center text-sm text-gray-600">{{ t('description.watingForVerifying') }}</p>
      </div>
    }

    <!-- Success State -->
    @if (isSuccess) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.verifyingSuccess') }}</h2>
        <div class="mt-4 space-y-2 text-center text-sm text-gray-600">
          <p>{{ t('description.verifyingSuccess') }}</p>
          <p class="text-gray-500">{{ t('redirected') }}</p>
        </div>
      </div>
    }

    <!-- Already Verified State (success with link to login) -->
    @if (isAlreadyVerified) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.alreadyVerified') }}</h2>
        <p class="mt-4 text-center text-sm text-gray-600">{{ t('description.alreadyVerified') }}</p>
        <a routerLink="/auth/login" class="btn btn-primary mt-6 inline-block">
          {{ t('backToLogin') }}
        </a>
      </div>
    }

    <!-- Error State -->
    @if (errorMessage) {
      <div class="text-center">
        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
          <svg class="text-signal-error h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">{{ t('title.verifyingFail') }}</h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          {{ errorMessage }}
        </p>
      </div>
    }
  </div>
</div>
